import { ModalEnum } from '@/interfaces'
import { useStores } from '@/stores/RootStoreContext'
import { Button, Flex } from 'antd'
import PropTypes from 'prop-types'

const Footer = (props) => {
    const { onConfirm, onBack, step } = props

    const { modalStore } = useStores()

    const closeModal = () => {
        modalStore.closeModal(ModalEnum.DOWNGRADE_PLAN)
    }

    if (step === 'confirmation') {
        return (
            <Flex justify="center">
                <Button
                    onClick={closeModal}
                    type="primary"
                    size="large"
                    shape="default"
                    style={{ borderRadius: 6 }}
                >
                    OK, fechar
                </Button>
            </Flex>
        )
    }

    if (step === 'reason') {
        return (
            <Flex justify="space-between">

                <Button
                    onClick={onConfirm}
                    color="primary"
                    variant="outlined"
                    size="large"
                    shape="default"
                    style={{ borderRadius: 6 }}
                >
                    Continuar com plano grátis
                </Button>
                <Button
                    onClick={onBack}
                    type="primary"
                    size="large"
                    shape="default"
                    style={{ borderRadius: 6 }}
                >
                    Quero manter minhas vantagens
                </Button>

            </Flex>
        )
    }
    if (step === 'password') {
        return (
            <Flex justify="space-between">
                <Button
                    size="large"
                    variant="outlined"
                    onClick={onConfirm}
                    style={{
                        borderRadius: 6,
                        padding: '12px 24px',
                        color: '#AD34FE',
                        borderColor: '#AD34FE',
                    }}
                >
                    Confirmar plano grátis
                </Button>
                <Button
                    type="primary"
                    size="large"
                    onClick={onBack}
                    style={{
                        borderRadius: 6,
                        padding: '12px 24px',
                    }}
                >
                    Quero manter minhas vantagens
                </Button>
            </Flex>
        )
    }

    // step === 'planComparison'
    return (
        <Flex gap={12} justify="space-between">
            <Button
                size="large"
                variant="outlined"
                onClick={onConfirm}
                style={{
                    borderRadius: 6,
                    padding: '12px 24px',
                    color: '#AD34FE',
                    borderColor: '#AD34FE',
                }}
            >
                Continuar com plano grátis
            </Button>
            <Button
                type="primary"
                size="large"
                onClick={closeModal}
                style={{
                    borderRadius: 6,
                    padding: '12px 24px',
                }}
            >
                Quero manter minhas vantagens
            </Button>
        </Flex>
    )
}

Footer.propTypes = {
    step: PropTypes.oneOf(['planComparison', 'reason', 'password', 'confirmation']).isRequired,
    onConfirm: PropTypes.func.isRequired,
    onBack: PropTypes.func,
}

export default Footer
